import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

export const SettlementsSummary = [
  {
    title: "Total Settlements",
    objKeyRepr: "totalCount",
    icon: <ReceiptLongOutlinedIcon fontSize="small" />,
  },
  {
    title: "Total Volume",
    objKeyRepr: "totalVolume",
    icon: <PaymentsOutlinedIcon fontSize="small" color="primary" />,
    isCurrency: true,
  },
  {
    title: "Successful",
    objKeyRepr: "successfulCount",
    icon: <CheckCircleOutlineIcon fontSize="small" color="success" />,
  },
  {
    title: "Pending",
    objKeyRepr: "pendingCount",
    icon: <HourglassEmptyOutlinedIcon fontSize="small" color="warning" />,
  },
  {
    title: "Failed",
    objKeyRepr: "failedCount",
    icon: <CancelOutlinedIcon fontSize="small" color="error" />,
  },
];
